import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faChevronDown, faCheckCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { btn, btnHoverStyle } from "../../../../../layout/Buttons/buttonStyles";
import Content from "../../../../../layout/Content";
import ProjectsHeader from "./ProjectsHeader";
import ProjectRow from "./ProjectRow";
import crudApi from "@serie3/common/api/crudApi";
import { useNavigate } from "react-router-dom";
import ProjectConfig from "@serie3/freelancesplaceapi/Config/Projects/ProjectConfig";
import listHandler from "@serie3/common/Domain/listHandler";
import ProjectView from "./ProjectView";
import getSettings from "@serie3/common/config/settings";
import PaymentModal from "../../../../../layout/Payment/PaymentModal";

const Index = () => {
  const [showRowError, setShowRowError] = useState(false);
  const [viewProject, setVieProject] = useState();
  const [showView, setShowView] = useState(false);
  const [projects, setProjects] = useState([]);
  const [showPayModal, setShowPayModal] = useState(false);
  const [settings, setSettings] = useState();
  const [filter, setFilter] = useState("Ongoing");

  const navigate = useNavigate();

  const createNew = async () => {
    const response = await crudApi.createNew(
      ProjectConfig.endpoints.new,
      { title: " ", done: 0 },
      setShowPayModal
    );
    if (response.status === 200) {
      navigate(ProjectConfig.endpoints.edit + "/" + response.data.id);
    } else {
      setShowRowError(true);
    }
  };

  const NewButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <div style={{ display: "inline-flex", gap: "8px", alignItems: "center" }}>
        <button className="btn-modern" style={{ ...btn.base, ...btn.primary }} onClick={createNew}>
          <FontAwesomeIcon icon={faPlus} /> New Project
        </button>

        <Dropdown>
          <Dropdown.Toggle
            as="button"
            className="btn-modern"
            style={{
              ...btn.base,
              ...btn.secondary,
              gap: "6px",
              border: "none",
              cursor: "pointer",
            }}
          >
            {filter === "Done"
              ? <><FontAwesomeIcon icon={faCheckCircle} style={{ color: "#2e7d32" }} /> Done</>
              : <><FontAwesomeIcon icon={faSpinner} style={{ color: "#1a73e8" }} /> Ongoing</>
            }
            <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: "0.7rem", color: "#9e9e9e" }} />
          </Dropdown.Toggle>
          <Dropdown.Menu style={{
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            border: "1px solid #f0f0f0",
            padding: "6px",
            marginTop: "4px",
          }}>
            <Dropdown.Item
              style={{ borderRadius: "7px", fontSize: "0.9rem" }}
              onClick={() => {
                setFilter("Ongoing");
                crudApi.getAll(ProjectConfig.endpoints.getOngoing, setProjects, "project");
              }}
            >
              <FontAwesomeIcon icon={faSpinner} style={{ color: "#1a73e8", marginRight: "8px" }} />
              Ongoing
            </Dropdown.Item>
            <Dropdown.Item
              style={{ borderRadius: "7px", fontSize: "0.9rem" }}
              onClick={() => {
                setFilter("Done");
                crudApi.getAll(ProjectConfig.endpoints.getDone, setProjects, "project");
              }}
            >
              <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#2e7d32", marginRight: "8px" }} />
              Done
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );

  useEffect(() => {
    crudApi.getAll(ProjectConfig.endpoints.getOngoing, setProjects, "project");
    setSettings(getSettings());
  }, []);

  const title = () => <b>Projects</b>;

  const editAction = (id) => navigate(ProjectConfig.endpoints.edit + "/" + id);

  const deleteAction = async (index, project) => {
    listHandler.deleteFromList(
      index,
      crudApi.del(ProjectConfig.endpoints.delete, project.id),
      setProjects,
      projects,
      setShowRowError
    );
  };

  const viewAction = (project) => {
    setVieProject(project);
    setShowView(true);
  };

  return projects ? (
    <>
      {viewProject && (
        <ProjectView show={showView} setShow={setShowView} projectId={viewProject.id} />
      )}
      {settings && (
        <PaymentModal
          show={showPayModal}
          setShow={setShowPayModal}
          priceTableId={settings.pricingTables.projects}
        />
      )}
      <ProjectsHeader />
      <Content Title={title} AdditionalButtons={NewButton}>
        {projects.length === 0 ? (
          <div style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#9e9e9e",
            fontSize: "0.95rem",
          }}>
            No projects found. Create your first project!
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "4px 0" }}>
            {projects.map((project, index) => (
              <ProjectRow
                key={index}
                editAction={() => editAction(project.id)}
                deleteAction={() => deleteAction(index, project)}
                viewAction={() => viewAction(project)}
                project={project}
              />
            ))}
          </div>
        )}
      </Content>
    </>
  ) : null;
};

export default Index;
